import type { AiCapabilityPage } from "../registry/schema.js";
import { normalizeViText } from "../vi-normalizer.js";

/**
 * 🔴 AI-INTERP I8 (@UC0396 · QĐ I8) — VIỆC APP CHƯA LÀM qua trợ lý: MỘT danh sách đóng (một nguồn) cho lưới ở Người làm.
 *
 * Vì sao: Sổ không có trang nào cho miễn tiền · hoàn tiền CHO thành viên · cho vay từ quỹ · tha nợ · chia lại tiền dư, nên Người
 * phiên dịch (chỉ thấy trang được phép) hút câu vào trang GHI gần chữ nhất — đo BM25 offline 23/10: "miễn tiền quỹ tháng này cho bé An" ⇒
 * PAY-ON-BEHALF/RECORD-PAID · "hoàn tiền 200k cho bé Na" ⇒ PAY-ON-BEHALF/INC-RECORD (INC-RECORD = tiền VỀ quỹ — chiều ngược) · "cho Lan vay 2tr
 * từ quỹ" ⇒ COL-RECURRING. Mở phiếu ở đó là mời người dùng ghi một việc KHÁC việc họ nói (thẻ xác nhận là chốt cuối, nhưng thẻ của một việc
 * sai vẫn là một lời mời ghi sai tiền).
 *
 * Luật — tất định, 0 LLM, cố ý HẸP (thà lọt một câu cho thẻ xác nhận chặn còn hơn chặn oan một việc làm được):
 *  1. Chỉ xét khi Phiếu chọn trang GHI (`T1`/`T2`); trang đọc/chuyển màn đi đường cũ.
 *  2. Câu chứa một CỤM của mục (so CÒN DẤU khi câu có dấu; câu không dấu so bảng không dấu đã gỡ chữ nước đôi — "vay" không dấu = "vậy").
 *     `*` trong cụm = 0..3 chữ bất kỳ ("cho * vay" ⇒ "cho Lan vay").
 *  3. Cụm `unless` của mục có mặt ⇒ không phải mục đó: "được hoàn" (tiền VỀ quỹ — INC-RECORD), "cho quỹ"/"vào quỹ"/"cho lớp"/"cho nhóm" (tiền
 *     về TẬP THỂ — vá review MED-1), "không cần trả lại" (quỹ giữ tiền thừa — ghi nhận thường, không phải tha nợ).
 *  3b. 🔴 Vá review MEDIUM M1 (02/11): chữ của mục chưa đủ — luật (`Rule`) đòi dấu hiệu HƯỚNG tiền mà chữ mục không nói (bản đầu chặn oan việc
 *     làm được, câu "chưa làm được" là nói sai sự thật): hoàn tiền ⇒ "cho <người>" (xưng hô · lượng từ · TÊN viết hoa) hoặc quỹ là chủ ngữ, trừ
 *     "nhận hoàn"/"cho đơn·vé·chuyến·hoá đơn" ("shop hoàn tiền 200k cho đơn áo lớp" = tiền VỀ quỹ); trả/hoàn tiền thừa ⇒ chỉ "… cho <nhiều người>"
 *     ("Hùng trả lại tiền thừa 50k" = trả VỀ quỹ); "miễn tiền" kèm động từ chi/nhận = bên ngoài miễn ("sân miễn tiền nước"), bỏ "miễn phí cho";
 *     "cho … mượn" ⇒ chỉ khi nói tiền/quỹ ("quán cho mượn bàn ghế"); "khỏi/không cần trả" ⇒ chỉ khi câu nói tới nợ/vay/mượn ("Hùng ứng 300k mua
 *     nước, khỏi trả" = tặng luôn). Cái MẤT: "cho Lan mượn 500k" (không chữ tiền/quỹ) lọt tới trang LLM chọn — thẻ xác nhận là chốt.
 *  3c. 🔴 Vá review vòng 2 MEDIUM: NGƯỜI TRẢ là thành viên/công ty có TÊN đứng trước động từ ("Hùng trả lại tiền 200k cho em", "Tiki hoàn tiền 120k cho
 *     Tour Sapa") ⇒ tiền VÀO quỹ ⇒ vế "cho <người>" / "tiền dư cho <nhiều người>" không tính (`notAfterNamedPayer`; xưng hô của người nói — "Em hoàn
 *     tiền 200k cho bé Na" — không phải tên ⇒ vẫn chặn); người nhận là thủ quỹ ("cho chị Hoa thủ quỹ") ⇒ tiền VỀ quỹ; "trả … vay/mượn" ĐỨNG TRƯỚC =
 *     trả lại khoản đã vay. Vòng 3 M1: tên gõ chữ THƯỜNG cũng nhận — sau xưng hô ("anh hung tra lai…") hoặc đầu câu sát động từ ("hung tra lai…").
 *     Cái MẤT: câu mở đầu bằng chữ viết hoa không phải tên ("Hôm qua hoàn tiền … cho Lan") lọt.
 *  4. 🔴 Vá review goppy-reviewer HIGH-2: KHÔNG có mục hiếu hỉ. Tiền mừng cưới / phúng viếng đi qua quỹ là việc THƯỜNG ở MỌI trang ghi (chi ·
 *     đợt góp · quỹ nhận · tự báo đã chuyển · ghi nhận · nộp hộ — "Lan đóng tiền mừng cưới cô giáo 200k"); sổ "ai mừng ai / đáp lễ" không có câu
 *     nào tách được khỏi các việc đó bằng chữ ⇒ chặn là chặn oan việc làm được.
 * Không đọc `hasNegationOrDoubt`: lưới không mở, không điền gì — chỉ CHẶN mở trang ghi; câu hỏi "có miễn tiền được không?" cũng không nên mở phiếu.
 */
export type AiUnsupportedIntentId = "waive" | "refund_member" | "fund_loan" | "forgive_debt" | "redistribute_surplus";

export interface AiUnsupportedIntent {
  readonly id: AiUnsupportedIntentId;
  /** Tên việc nói với người dùng (chuỗi catalog, không phải chữ của câu). */
  readonly label: string;
}

interface Phrases {
  readonly accented: readonly string[];
  readonly plain: readonly string[];
}

/**
 * Một luật của mục: câu chứa một cụm `phrases`, VÀ (nếu khai) chứa một cụm `needs`, VÀ không chứa cụm `unless` của luật. Vá review MEDIUM M1
 * (02/11): chữ của mục chưa đủ — luật đòi dấu hiệu HƯỚNG tiền mà chữ mục không nói ("hoàn tiền … cho đơn hàng" là tiền VỀ quỹ).
 */
interface Rule {
  readonly phrases: Phrases;
  readonly needs?: Phrases;
  readonly unless?: Phrases;
  /**
   * Vá review vòng 2 MEDIUM: cụm (bắt đầu ở động từ hoàn/trả) KHÔNG tính khi TRƯỚC nó có chủ ngữ là một NGƯỜI có tên — chữ viết hoa (kể cả đứng đầu
   * câu) không thuộc `NOT_A_PAYER_NAME` ("Hùng trả lại tiền 200k cho em" = thành viên trả VỀ quỹ; "Tiki hoàn tiền … cho Tour Sapa" = công ty hoàn).
   */
  readonly notAfterNamedPayer?: true;
}

interface Entry extends AiUnsupportedIntent {
  readonly rules: readonly Rule[];
  readonly unless?: Phrases;
}

const TO_FUND: Phrases = { accented: ["cho quỹ", "vào quỹ", "về quỹ", "lại quỹ"], plain: ["cho quy", "vao quy", "ve quy", "lai quy"] };
/** Vá review MED-1: tiền VỀ tập thể ("shop hoàn lại 100k cho lớp") — chiều ngược của hoàn/chia tiền CHO thành viên. */
const TO_GROUP: Phrases = {
  accented: [...TO_FUND.accented, "cho lớp", "cho nhóm", "cho đội", "cho hội", "vào lớp", "vào nhóm"],
  plain: [...TO_FUND.plain, "cho lop", "cho nhom", "cho doi", "cho hoi", "vao lop", "vao nhom"],
};
/** Vá review MED-1: "không cần trả lại tiền thừa" = quỹ GIỮ tiền thừa (ghi nhận thường), không phải tha nợ hay chia lại. */
const KEEP_CHANGE: Phrases = { accented: ["khỏi trả lại", "không cần trả lại"], plain: ["khoi tra lai", "khong can tra lai"] };
/** Vá review M1: tiền hoàn VỀ quỹ — người bán/nhà xe hoàn "cho đơn/vé/chuyến/hoá đơn", quỹ "nhận/được hoàn". */
const REFUND_IN: Phrases = {
  // vá review vòng 2: người nhận là THỦ QUỸ ("… cho chị Hoa thủ quỹ") = tiền VỀ quỹ; "cho chi phi" không dấu = chi phí, không phải "cho chị".
  accented: ["được hoàn", "nhận hoàn", "cho đơn", "cho vé", "cho chuyến", "cho hoá đơn", "cho hóa đơn", "cho * thủ quỹ", ...TO_GROUP.accented],
  plain: ["duoc hoan", "nhan hoan", "cho don", "cho ve", "cho chuyen", "cho hoa don", "cho * thu quy", "cho chi phi", ...TO_GROUP.plain],
};
/** Động từ hoàn/trả tiền — chiều không rõ (shop hoàn cho quỹ hay quỹ hoàn cho người?) ⇒ luật đòi thêm người nhận. */
const REFUND_VERBS: Phrases = { accented: ["hoàn tiền", "hoàn lại", "hoàn trả", "trả lại tiền", "hoàn tiền lại"], plain: ["hoan tien", "hoan lai", "hoan tra", "tra lai tien"] };
/** Động từ trả/hoàn TIỀN DƯ — một người trả tiền thừa về quỹ là ghi nhận thường; chỉ "… cho <nhiều người>" mới là chia lại. */
const SURPLUS_RETURN: Phrases = {
  accented: ["trả lại tiền dư", "trả lại tiền thừa", "hoàn tiền dư", "hoàn tiền thừa", "hoàn lại tiền dư", "hoàn lại tiền thừa"],
  plain: ["tra lai tien du", "tra lai tien thua", "hoan tien du", "hoan tien thua", "hoan lai tien du", "hoan lai tien thua"],
};
const suffixed = (p: Phrases, accented: string, plain: string): Phrases => ({ accented: p.accented.map((x) => `${x} ${accented}`), plain: p.plain.map((x) => `${x} ${plain}`) });
const prefixed = (p: Phrases, accented: string, plain: string): Phrases => ({ accented: p.accented.map((x) => `${accented} ${x}`), plain: p.plain.map((x) => `${plain} ${x}`) });

export const AI_UNSUPPORTED_INTENTS: readonly Entry[] = Object.freeze([
  {
    id: "waive",
    label: "miễn tiền cho thành viên",
    rules: [
      { phrases: { accented: ["miễn đóng", "miễn quỹ", "miễn khoản", "miễn cho"], plain: ["mien dong", "mien quy", "mien khoan", "mien cho"] } },
      // vá review M1: "sân miễn tiền nước" kèm một khoản CHI/NHẬN = bên ngoài miễn cho nhóm, không phải nhóm miễn cho thành viên. ("miễn phí cho"
      // đã bỏ: "nhà hàng miễn phí cho cả đội" cùng nghĩa.)
      // Không dấu "chi" = chi HOẶC chị ("mien tien quy cho chi Lan") ⇒ chỉ "chi <số>"/"chi tien" là động từ chi (vá review vòng 2).
      { phrases: { accented: ["miễn tiền"], plain: ["mien tien"] }, unless: { accented: ["chi", "nhận"], plain: ["chi <so>", "chi tien", "nhan"] } },
    ],
  },
  {
    id: "refund_member",
    label: "hoàn tiền cho thành viên",
    // vá review M1: người NHẬN là người ("cho <người>": xưng hô · lượng từ · TÊN viết hoa) hoặc quỹ là chủ ngữ ("quỹ … hoàn tiền … cho").
    // vá review vòng 2: vế "cho <người>" không tính khi người TRẢ là thành viên có tên đứng trước động từ (tiền VÀO quỹ).
    rules: [
      { phrases: suffixed(REFUND_VERBS, "* cho <nguoi>", "* cho <nguoi>"), notAfterNamedPayer: true },
      { phrases: prefixed(suffixed(REFUND_VERBS, "* cho", "* cho"), "quỹ *", "quy *") },
    ],
    unless: REFUND_IN,
  },
  {
    id: "fund_loan",
    label: "cho vay từ quỹ",
    rules: [
      {
        phrases: {
          accented: ["cho vay", "cho * vay", "vay quỹ", "vay tiền quỹ", "vay từ quỹ", "mượn quỹ", "mượn tiền quỹ", "mượn từ quỹ"],
          plain: ["cho * vay * quy", "vay quy", "vay tien quy", "vay tu quy", "muon quy", "muon tien quy", "muon tu quy"],
        },
      },
      // vá review M1: "quán cho mượn bàn ghế" = mượn ĐỒ ⇒ "cho … mượn" chỉ khi nói tới tiền/quỹ (sau "mượn", hoặc quỹ là chủ ngữ).
      { phrases: { accented: ["cho * mượn * quỹ", "cho * mượn * tiền", "quỹ * cho * mượn"], plain: ["cho * muon * quy", "cho * muon * tien", "quy * cho * muon"] } },
    ],
    // vá review vòng 2: "trả … vay/mượn" ĐỨNG TRƯỚC = trả lại khoản đã vay ("Hùng trả nợ vay quỹ 500k") — tiền VỀ quỹ, không phải cho vay. Vòng 3: chỉ khi
    // nói tới KHOẢN vay (tiền vay · nợ vay · khoản vay · tiền mượn) — "Lan đã trả tiền, giờ muốn vay quỹ 500k" là xin vay ⇒ vẫn chặn.
    unless: {
      accented: [...TO_FUND.accented.filter((p) => p !== "cho quỹ"), "trả * tiền vay", "trả * nợ vay", "trả * khoản vay", "trả * tiền mượn"],
      plain: [...TO_FUND.plain.filter((p) => p !== "cho quy"), "tra * tien vay", "tra * no vay", "tra * khoan vay", "tra * tien muon"],
    },
  },
  {
    id: "forgive_debt",
    label: "tha nợ",
    rules: [
      { phrases: { accented: ["tha nợ", "xoá nợ", "xóa nợ", "xoá khoản nợ", "xóa khoản nợ", "bỏ nợ"], plain: ["tha no", "xoa no", "xoa khoan no"] } },
      // vá review M1: "Hùng ứng 300k mua nước, khỏi trả" = người ứng TẶNG luôn (việc làm được) ⇒ "khỏi/không cần trả" chỉ khi câu nói tới một khoản NỢ.
      // Không dấu: "no"/"vay"/"muon" trùng nó/vậy/muốn ⇒ chỉ cụm rõ.
      {
        phrases: { accented: ["khỏi trả", "không cần trả"], plain: ["khoi tra", "khong can tra"] },
        needs: { accented: ["nợ", "vay", "mượn"], plain: ["khoan no", "tien no", "vay quy", "muon quy"] },
      },
    ],
    unless: KEEP_CHANGE,
  },
  {
    id: "redistribute_surplus",
    label: "chia lại tiền dư",
    rules: [
      {
        phrases: {
          accented: ["chia lại tiền dư", "chia lại tiền thừa", "chia tiền dư", "chia tiền thừa", "chia số dư", "chia lại số dư", "chia lại quỹ", "chia quỹ", "chia tiền quỹ"],
          plain: ["chia lai tien du", "chia lai tien thua", "chia tien du", "chia tien thua", "chia so du", "chia lai so du", "chia lai quy", "chia quy", "chia tien quy"],
        },
      },
      // vá review M1: "Hùng trả lại tiền thừa 50k" = một người trả tiền thừa VỀ quỹ ⇒ chỉ "… cho <nhiều người>" mới là chia lại.
      { phrases: suffixed(SURPLUS_RETURN, "* cho <nhieu>", "* cho <nhieu>"), notAfterNamedPayer: true },
    ],
    unless: { accented: [...TO_GROUP.accented, ...KEEP_CHANGE.accented], plain: [...TO_GROUP.plain, ...KEEP_CHANGE.plain] },
  },
] satisfies readonly Entry[]);

/** Trần chữ bất kỳ mà một `*` nuốt. */
const GAP_MAX_WORDS = 3;

/**
 * Chỗ trống có tên trong cụm (vá review M1): `<nguoi>` = người nhận là người — xưng hô/lượng từ (bé · anh · chị · em · phụ huynh · từng · mỗi ·
 * các · mọi người) hoặc một TÊN viết hoa ("cho Lan"); `<nhieu>` = nhiều người (mọi · các · từng · mỗi · cả). So theo dạng của câu (còn dấu / không dấu).
 */
const SLOT_WORDS: Readonly<Record<string, Phrases>> = {
  // `<so>` = một chữ bắt đầu bằng CHỮ SỐ ("300k", "2tr") — xét riêng trong `matchesAt`.
  "<nguoi>": { accented: ["bé", "anh", "chị", "em", "phụ", "từng", "mỗi", "các", "mọi"], plain: ["be", "anh", "chi", "em", "phu", "tung", "moi", "cac"] },
  "<nhieu>": { accented: ["mọi", "các", "từng", "mỗi", "cả"], plain: ["moi", "cac", "tung", "ca"] },
};

interface SentenceWord {
  /** Chữ để so (thường; còn dấu hoặc đã bỏ dấu tuỳ câu). */
  readonly w: string;
  /** Chữ gõ viết hoa đầu — dấu hiệu TÊN riêng cho `<nguoi>`. */
  readonly cap: boolean;
}

function rawWordsOf(text: string): string[] {
  return text
    .normalize("NFC")
    .split(/[^\p{L}\p{N}]+/u)
    .filter((w) => w.length > 0);
}

/** Cụm (chữ cách nhau bằng dấu cách, `*` = 0..GAP_MAX_WORDS chữ, `<…>` = chỗ trống có tên) xuất hiện trong `words` bắt đầu ở `at`, khớp từ chữ thứ `k`. */
function matchesAt(words: readonly SentenceWord[], parts: readonly string[], at: number, k: number, accented: boolean): boolean {
  if (k === parts.length) return true;
  const part = parts[k]!;
  if (part === "*") {
    for (let gap = 0; gap <= GAP_MAX_WORDS && at + gap <= words.length; gap++) if (matchesAt(words, parts, at + gap, k + 1, accented)) return true;
    return false;
  }
  if (at >= words.length) return false;
  const word = words[at]!;
  const slot = SLOT_WORDS[part];
  const hit =
    part === "<so>" ? /^\p{Nd}/u.test(word.w) : slot === undefined ? word.w === part : (accented ? slot.accented : slot.plain).includes(word.w) || (part === "<nguoi>" && word.cap);
  return hit && matchesAt(words, parts, at + 1, k + 1, accented);
}

/** Mọi vị trí (chỉ số chữ) mà cụm bắt đầu khớp. */
function phraseStarts(words: readonly SentenceWord[], phrase: string, accented: boolean): number[] {
  const parts = phrase.split(" ");
  const out: number[] = [];
  for (let i = 0; i < words.length; i++) if (matchesAt(words, parts, i, 0, accented)) out.push(i);
  return out;
}

/**
 * Chữ viết hoa KHÔNG phải tên người trả: xưng hô/đại từ của người nói ("Em hoàn tiền 200k cho bé Na" = thủ quỹ hoàn RA — vẫn chặn), quỹ/thủ quỹ, lời
 * nhờ/lệnh đứng đầu câu. Tập ĐÓNG — sót một chữ ⇒ câu đó lọt (đi đường thường, thẻ xác nhận là chốt), không bao giờ chặn oan thêm.
 */
const NOT_A_PAYER_NAME: Phrases = {
  accented: ["em", "anh", "chị", "mình", "tôi", "tui", "tớ", "chú", "cô", "bác", "cháu", "con", "bạn", "quỹ", "thủ", "hãy", "nhờ", "giúp", "ghi", "cho"],
  plain: ["em", "anh", "chi", "minh", "toi", "tui", "to", "chu", "co", "bac", "chau", "con", "ban", "quy", "thu", "hay", "nho", "giup", "ghi", "cho"],
};

/**
 * Vá review vòng 3 M1: trợ từ/trợ động từ đứng giữa chủ ngữ và động từ ("em VỪA hoàn tiền…", "cần hoàn tiền…") — không bao giờ là tên người trả.
 * Không dấu: bỏ "van" (= Vân).
 */
const AUX_WORDS: Phrases = {
  accented: ["đã", "vừa", "mới", "sẽ", "cần", "phải", "nên", "muốn", "định", "sắp", "cũng", "vẫn", "xin", "để", "thì", "mà"],
  plain: ["da", "vua", "moi", "se", "can", "phai", "nen", "muon", "dinh", "sap", "cung", "xin", "de", "thi", "ma"],
};
/** Xưng hô đứng TRƯỚC một tên ("anh hung", "chị lan", "bé Na") — cặp này là người trả có tên, dù tên gõ chữ thường. */
const HONORIFIC_BEFORE_NAME: Phrases = {
  accented: ["anh", "chị", "em", "bé", "cô", "chú", "bác", "cháu", "con", "bạn", "ông", "bà", "cậu", "dì"],
  plain: ["anh", "chi", "em", "be", "co", "chu", "bac", "chau", "con", "ban", "ong", "ba", "cau", "di"],
};

/**
 * Trước chữ thứ `at` (động từ hoàn/trả) có NGƯỜI TRẢ có tên — vế `notAfterNamedPayer`. Một chữ (không thuộc `NOT_A_PAYER_NAME`, không phải trợ từ) là
 * tên người trả khi: viết HOA (vòng 2 — kể cả đầu câu: "Hùng trả lại…", "Tiki hoàn tiền…"); hoặc (vòng 3 M1, tên gõ chữ THƯỜNG) đứng ngay sau một xưng hô
 * ("anh hung tra lai…") hoặc đứng ĐẦU câu mà giữa nó và động từ chỉ có trợ từ ("hung tra lai…", "hung da tra lai…"). Xưng hô đứng SÁT động từ ("em hoàn
 * tiền…", "em vừa hoàn tiền…") là NGƯỜI NÓI ⇒ không phải người trả ⇒ vẫn chặn.
 */
function namedPayerBefore(words: readonly SentenceWord[], at: number, accented: boolean): boolean {
  const pick = (p: Phrases): readonly string[] => (accented ? p.accented : p.plain);
  const notName = pick(NOT_A_PAYER_NAME);
  const aux = pick(AUX_WORDS);
  const honorific = pick(HONORIFIC_BEFORE_NAME);
  return words.slice(0, at).some((x, i) => {
    if (notName.includes(x.w) || aux.includes(x.w)) return false;
    if (x.cap) return true;
    if (i > 0 && honorific.includes(words[i - 1]!.w)) return true;
    return i === 0 && words.slice(1, at).every((y) => aux.includes(y.w));
  });
}

/**
 * Việc chưa làm được mà câu nói tới, khi Phiếu chọn trang GHI `page` — hoặc `null` (đường cũ). Thuần, tất định, 0 LLM.
 * Mục đầu khớp thắng (thứ tự bảng).
 */
export function unsupportedWriteIntentFromSentence(sentence: string, page: Pick<AiCapabilityPage, "id" | "tier">): AiUnsupportedIntent | null {
  if (page.tier !== "T1" && page.tier !== "T2") return null;
  const raw = rawWordsOf(sentence);
  if (raw.length === 0) return null;
  const lower = raw.map((w) => w.toLocaleLowerCase("vi"));
  const plain = lower.map((w) => normalizeViText(w));
  const accented = plain.some((w, i) => w !== lower[i]);
  const words: SentenceWord[] = raw.map((w, i) => ({ w: accented ? lower[i]! : plain[i]!, cap: /^\p{Lu}/u.test(w) }));
  const starts = (p: Phrases): number[] => (accented ? p.accented : p.plain).flatMap((x) => phraseStarts(words, x, accented));
  const any = (p: Phrases | undefined): boolean => p !== undefined && starts(p).length > 0;
  const hits = (r: Rule): boolean => starts(r.phrases).some((i) => r.notAfterNamedPayer !== true || !namedPayerBefore(words, i, accented));
  for (const e of AI_UNSUPPORTED_INTENTS) {
    if (!e.rules.some((r) => hits(r) && (r.needs === undefined || any(r.needs)) && !any(r.unless))) continue;
    if (any(e.unless)) continue;
    return { id: e.id, label: e.label };
  }
  return null;
}
